import React, { useEffect, useState } from "react";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Modal from "@material-ui/core/Modal";
import { connect } from "react-redux";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { generateForecastedDOE, updateForecastedDOE } from "../../../../store/modules/valuation/actions";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import FinancialHandler from "../../../../handlers/FinancialHandler";
import CurrencyFormatter from "currency-formatter";
import YearBar from "../YearBar";
import Subtitle from "../Subtitle";
import MethodSelection from "../MethodSelection";
import Item from "./Item";
import SingleChart from "../../../../components/BVAChart/SingleChart";
import DoubleChart from "../../../../components/BVAChart/DoubleChart";
import MultiChart from "../../../../components/BVAChart/MultiChart";
import "../modal.css";

function ForecastedDOE({
  forecastedDOE,
  dispatchGenerateForecastedDOE,
  dispatchUpdateForecastedDOE,
}) {

  const [modalVisibility, setModalVisibility] = useState(false);
  const [checked, setChecked] = useState(false);

  // Mounted
  useEffect(() => {
    dispatchGenerateForecastedDOE();
  }, []);

  const handleChange = (type, value, date = "") => {
    dispatchUpdateForecastedDOE(type, value, date);
  };

  const handleModalClose = () => setModalVisibility(false);

  const handleModalOpen = () => {
    setModalVisibility(true);
  }

  const handleButtonClick = () => {
    handleModalOpen();
  };

  const handleOnClickGPT = async () => {
    handleChange("Note", "Generating...");
    const note = await FinancialHandler.fetchGPTForecastNoteGeneration(
      "DOEForecast",
      forecastedDOE.method,
      forecastedDOE.yearsFormatted,
      forecastedDOE.DOE,
      forecastedDOE.yearsTotal[forecastedDOE.yearsTotal.length - 1],
      forecastedDOE.forecastedValue,
      forecastedDOE.forecastedDOE
    );
    handleChange("Note", note);
  }

  //consts for charts
  const linearSearies = forecastedDOE?.DOEArray?.concat([forecastedDOE.linearValue]);
  const weightsSearies = forecastedDOE?.DOEArray?.concat([forecastedDOE.weightsValue]);
  const manualSearies = forecastedDOE?.DOEArray?.concat([forecastedDOE.manualValue]);
  const exponentialSearies = forecastedDOE?.DOEArray?.concat([forecastedDOE.exponentialValue]);

  return (
    <div>
      {forecastedDOE ?
        (<div>
          <Modal className="modal" onClose={handleModalClose} open={modalVisibility}>
            <div className="modal-main">
              {checked ?
                <MultiChart
                  label={forecastedDOE.yearsTotal}
                  title="Forecasted Discretionary Owner Earnings"
                  yTitle="DOE"
                  series={[{
                    name: 'Linear Trend',
                    type: 'area',
                    data: linearSearies
                  }, {
                    name: 'Weights',
                    type: 'area',
                    data: weightsSearies
                  }, {
                    name: 'Manual',
                    type: 'area',
                    data: manualSearies
                  }, {
                    name: 'Exponential',
                    type: 'area',
                    data: exponentialSearies
                  }]}
                />
                :
                <>
                  {/* <SingleChart
                    label={forecastedDOE.yearsTotal}
                    title="Forecasted Discretionary Owner Earnings"
                    yTitle="DOE"
                    seriesArray={forecastedDOE.DOEArray?.concat([forecastedDOE.forecastedValue])}
                    forecastedValue={forecastedDOE.forecastedValue}
                  /> */}
                  <DoubleChart
                    label={forecastedDOE.yearsTotal}
                    title="Forecasted Discretionary Owner Earnings"
                    yTitle="DOE"
                    name1="Sales Revenue"
                    name2="YoY Change"
                    series1={forecastedDOE.DOEArray?.concat([forecastedDOE.forecastedValue])}
                    series2={forecastedDOE.yoyArray}
                    minYaxis={forecastedDOE.minYaxis}
                    forecastedValue={forecastedDOE.forecastedValue}
                  />
                </>
              }
              <div className="flex justify-between mx-20 pl-10">
                <FormControlLabel control={<Checkbox checked={checked} onChange={(e) => setChecked(!checked)} />} label="Show all" />
                <MethodSelection value={forecastedDOE.method} handleChange={(e) => handleChange("Method", e.target.value)} />
              </div>
            </div>
          </Modal>

          <div className="flex items-center justify-between pr-10">
            <div className="flex items-center">
              <h2 className="sectionHead pr-3">Forecasted Discretionary Owner Earnings</h2>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
                <Select value={forecastedDOE.source} onChange={(e) => handleChange("Source", e.target.value)} >
                  <MenuItem value={"Survey"}>Survey</MenuItem>
                  <MenuItem value={"Report"}>Report</MenuItem>
                </Select>
              </FormControl>
            </div>
            <MethodSelection value={forecastedDOE.method} handleChange={(e) => handleChange("Method", e.target.value)} />

          </div>
          
          <div className="pb-10">
          
            <Subtitle title="Forecasted Discretionary Owner Earnings" />
            <YearBar data={forecastedDOE.yearsTotal} />

            {/* DOE Estimate */}
            <div className="flex items-center font-semibold mt-5">
              <div className="whitespace-nowrap flex items-center" style={{ minWidth: "18em" }}>
                Discretionary Owner Earnings Esti.
              </div>
              <div className="flex">
                {forecastedDOE.DOE?.map((obj) => (
                  <div className="flex justify-center" style={{ minWidth: "10em" }}>
                    {CurrencyFormatter.format(obj?.value, { code: "USD" })}
                  </div>
                ))}
              </div>
              <div className="flex justify-center" style={{ minWidth: "10em" }}>
                {forecastedDOE.method === "Manual" ?
                  <BVAInput
                    startAdornment
                    startAdornmentLabel="$ "
                    width="95%"
                    size="small"
                    value={forecastedDOE.forecastedValue}
                    onChange={(value) => handleChange("ManualValue", value)}
                  />
                  :
                  CurrencyFormatter.format(forecastedDOE.forecastedValue, { code: "USD" })
                }
              </div>
              <button
                className="chartBtn text-xl"
                style={{ minWidth: "3em" }}
                onClick={() => handleButtonClick()}
              >
                &#128202;
              </button>
            </div>

            {/* YoY Change */}
            <div className="flex mt-5">
              <div className="whitespace-nowrap flex" style={{ minWidth: "18em" }}>
                YoY Change
              </div>
              <div className="flex">
                {forecastedDOE.yoyArray?.map((val) => (
                  <div className="flex justify-center" style={{ minWidth: "10em" }}>
                    {val === null ? "" : val + "%"}
                  </div>
                ))}
              </div>
            </div>

            {/* Weights input */}
            {forecastedDOE.method === "Weights" ?
              (<div className="flex items-center mt-5">
                <div className="whitespace-nowrap flex items-center" style={{ minWidth: "18em" }}>
                  Weights
                </div>
                <div className="flex">
                  {forecastedDOE?.weights?.map((item) => (
                    <div className="flex items-center" style={{ width: "10em" }}>
                      <BVAInput
                        startAdornment
                        width="95%"
                        size="small"
                        key={item.date}
                        value={item.value}
                        onChange={(value) => handleChange("Weights", value, item.date)}
                      />
                    </div>
                  ))}
                </div>
              </div>)
              :
              (<div />)
            }

            <Subtitle title="Forecast of Long-term Discretionary Owner Earnings" />
            <Item name="Estimated Discretionary Owner Earnings" data={forecastedDOE.forecastedValue} />
            <Item name="Growth Rate" data={forecastedDOE.growthRate} margin={true} />
            <Item name="Forecasted Discretionary Owner Earnings" data={forecastedDOE.forecastedDOE} bold={true} />

            {/* Analyst note */}
            <div className="data-bottom pt-5">
              <h5 className="noteHead">Analyst Note&nbsp;&nbsp;&nbsp;<button onClick={() => handleOnClickGPT()}>🤖</button></h5>
              <textarea
                className="analystNote px-3 py-1"
                style={{ width: forecastedDOE.yearsFormatted?.length * 10 + 27 + "em" }}
                rows={3}
                value={forecastedDOE.analystNote}
                onChange={(e) => handleChange("Note", e.target.value)}
              />
            </div>
          </div>
        </div>)
        :
        (<div />)
      }
    </div>
  );
}

const mapStateToProps = (state) => ({
  forecastedDOE: state.valuation.forecastedDOE,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateForecastedDOE() {
    await dispatch(generateForecastedDOE());
  },
  async dispatchUpdateForecastedDOE(type, value, date) {
    await dispatch(updateForecastedDOE(type, value, date));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ForecastedDOE);